<script>
	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'warehouseForm',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<vxe-table style="display:none" height="0" ref="warehouseGoodsExportTable" data={this.exportData}>
				<vxe-column field="goodscode" title="商品编码" cell-type="string"></vxe-column>
				<vxe-column field="goodsname" title="商品名称" cell-type="string"></vxe-column>
				<vxe-column field="goodsmodel" title="规格型号" cell-type="string"></vxe-column>
				<vxe-column field="goodsbottom" title="下限" cell-type="string"></vxe-column>
				<vxe-column field="goodstop" title="上限" cell-type="string"></vxe-column>
				<vxe-column field="warehousename" title="仓库名称" cell-type="string"></vxe-column>
				</vxe-table>,
			]
			return formBase.render.call(this, h)
		},
		data() {
			return {
				exportData: [],
				loading: false
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			// beforeSubmit(formData, next) {
			// 	let $son_warehouse_goods = this.fApi.el('$son_warehouse_goods')
			// 	$son_warehouse_goods.submit().then((res) => {
			// 		if (res) {
			// 			formData.$son_warehouse_goods = res
			// 			next()
			// 		}
			// 	})
			// },
			batchdelete_warehouse_goods(){
				let $son_warehouse_goods = this.fApi.el('$son_warehouse_goods')
				let data = $son_warehouse_goods.getGrid().getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				$son_warehouse_goods.getGrid().remove(data)
				
			},
			regestEvent(rule, fApi) {
				let $son_warehouse_goods = this.fApi.el('$son_warehouse_goods')
				$son_warehouse_goods.store.form = this
				// fApi.mergeRule('$son_warehouse_goods', {
				// 	props: {
				// 		mainid: this.id
				// 	}
				// })
				fApi.mergeRule('$son_warehouse_goods', {
					on: {
						importtemplate: this.warehouseGoodsImporttemplate,
					}
				})
			},
			warehouseGoodsImporttemplate() {
				this.$store.commit('getTemplate', 'warehouse_goods')
			},

			importMethod(e) {
				let file = e.file
				let formData = new FormData()
				formData.append('excle', file)
				return new Promise((resolve) => {
					this.$api[this.name].goodsimport(this.id, formData).then((res) => {
						if (res.errorData.length != 0) {
							let message = ''
							res.errorData.forEach((item) => {
								message = message + item.goodscode + '：' + item.erro + '</br>'
							})

							this.$alert(message + '系统已忽略', res.errorData.length + '条数据错误', {
								dangerouslyUseHTMLString: true
							})
						}
						this.fApi.el('$son_warehouse_goods').loadTableData()
						resolve()
					}, (e) => {
						this.$message.error(e)
						resolve()
					})
				})


			},
			exportMethod() {
				this.loading = true
				this.$api[this.name].goodsexport({
					warehouseid: this.id
				}).then((res) => {
					if (res.length != 0) {
						this.exportData = res
						this.$refs.warehouseGoodsExportTable.exportData({
							filename: res[0]['warehousename'] + '_warehouse_goods_export',
							type: 'xlsx',
							data: res,
						})
					} else {
						this.$message.error('暂无数据')
					}
					this.loading = false
				})
			}

		},
		components: {

		}
	}
</script>
